var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#003B5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1251 17.9125C36.8433 16.4493 36.137 14.5702 36.1376 12.625H30.3438V35.875C30.2991 37.1332 29.7679 38.3249 28.8621 39.1993C27.9563 40.0736 26.7465 40.5623 25.4875 40.5625C22.825 40.5625 20.6125 38.3875 20.6125 35.6875C20.6125 32.4625 23.725 30.0437 26.9313 31.0375V25.1125C20.4625 24.25 14.8 29.275 14.8 35.6875C14.8 41.9312 19.975 46.375 25.4688 46.375C31.3563 46.375 36.1376 41.5938 36.1376 35.6875V23.8938C38.4869 25.581 41.3076 26.4862 44.2001 26.4813V20.6875C44.2001 20.6875 40.6751 20.8563 38.1251 17.9125Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/TiktokIcon.4479f995a44c1c056ea08b285146562b.svg";
export { ForwardRef as ReactComponent };